import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "grain", "scanlines", "static"]

  connect() {
    this.setupVideo()
    this.animateGrain()
    this.setupDynamicFilters()
  }

  disconnect() {
    if (this.grainInterval) {
      clearInterval(this.grainInterval)
    }
    if (this.filterInterval) {
      clearInterval(this.filterInterval)
    }
  }

  setupVideo() {
    const video = this.videoTarget
    
    // S'assurer que la vidéo démarre
    video.play().catch(() => {})
    
    // Appliquer un filtre de base
    video.style.transition = 'filter 2s ease'
  }

  animateGrain() {
    let offset = 0
    
    this.grainInterval = setInterval(() => {
      offset += 1
      
      // Animer le grain fractal
      if (this.hasGrainTarget) {
        const x = Math.sin(offset * 0.02) * 5
        const y = Math.cos(offset * 0.03) * 5
        this.grainTarget.style.transform = `translate(${x}px, ${y}px)`
        const opacity = 0.5 + Math.sin(offset * 0.01) * 0.3
        this.grainTarget.style.opacity = opacity
      }
      
      // Animer les scanlines
      if (this.hasScanlinesTarget) {
        const scanOffset = (offset * 2) % 10
        this.scanlinesTarget.style.backgroundPosition = `0 ${scanOffset}px`
      }
      
      // Animer le static
      if (this.hasStaticTarget) {
        const staticOpacity = 0.2 + Math.random() * 0.3
        this.staticTarget.style.opacity = staticOpacity
        const staticX = Math.random() * 5 - 2.5
        const staticY = Math.random() * 5 - 2.5
        this.staticTarget.style.transform = `translate(${staticX}px, ${staticY}px)`
      }
    }, 50)
  }

  setupDynamicFilters() {
    const video = this.videoTarget
    let filterOffset = 0
    
    // Variation INTENSE des filtres dans le temps
    this.filterInterval = setInterval(() => {
      filterOffset += 0.01
      
      // Variations plus fortes
      const contrast = 1.5 + Math.sin(filterOffset) * 0.2
      const brightness = 0.75 + Math.sin(filterOffset * 1.3) * 0.1
      const saturate = 0.5 + Math.sin(filterOffset * 0.7) * 0.3
      const grayscale = 0.4 + Math.sin(filterOffset * 0.5) * 0.2
      const sepia = 0.3 + Math.sin(filterOffset * 0.3) * 0.1
      const blur = 0.3 + Math.sin(filterOffset * 2) * 0.2
      
      video.style.filter = `contrast(${contrast}) brightness(${brightness}) saturate(${saturate}) grayscale(${grayscale}) sepia(${sepia}) blur(${blur}px) hue-rotate(${Math.sin(filterOffset * 0.5) * 10}deg)`
    }, 100)
  }
}